import React from 'react'
import './App.css'
import Board from './Board'

export default function App() {
  document.title = "Tic Tac Toe"
  return (
      <Board />
        )
}
